import { isBefore } from '@epicuro-next/utilities';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { DabHistory } from 'graphql-api/gql-api-interfaces';

import * as dabActions from './dab.actions';

/**
 * P-Basket feature key
 */
export const DAB_HISTORY_FEATURE_KEY = 'dabHistory';

export type DabHistoryState = EntityState<DabHistory>;

export function selectDabHistoryId(data: DabHistory): string {
  return `${data.brandId}-${data.productId}-${data.order}-${data.type}-${data.deliveryDate}`;
}

/** State adapter */
export const adapter: EntityAdapter<DabHistory> =
  createEntityAdapter<DabHistory>({
    selectId: selectDabHistoryId,
    sortComparer: itemsComparer,
  });

/**
 * The initial p-basket state
 */
export const initialState: DabHistoryState = adapter.getInitialState();

/**
 * Product basket reducer
 */
const dabHistoryReducer = createReducer(
  initialState,
  on(
    dabActions.loadDabHistorySuccess,
    (state, { dabHistoryData }): DabHistoryState => {
      return adapter.setAll(dabHistoryData, state);
    },
  ),
);

/**
 * Reducer export
 * @param state The current state
 * @param action The action dispatched
 */
export function reducer(state: DabHistoryState | undefined, action: Action) {
  return dabHistoryReducer(state, action);
}

function itemsComparer(a: DabHistory, b: DabHistory) {
  return isBefore(new Date(a.deliveryDate), new Date(b.deliveryDate)) ? 1 : 0;
}
